// External Dependencies:
import React from 'react'
import AudioRecorder from 'utilities/AudioRecorder'

class Record extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			hasError: false,
			isRecording: false,
			finishedRecording: false,
			recordingPreview: false,
			duration: '0',
			extension: '',
			audioBlob: false
		}
	}

	static defaultProps = {
		handleError: false
	}

	componentDidMount() {
		this.setupRecorder()
	}

	setupRecorder = () => {
		this.recorder = new AudioRecorder()
		this.recorder.em.addEventListener( 'recording', ( e ) => this.onNewRecording( e ) )
	}

	startRecording = () => {
		this.setState({
			finishedRecording: false,
			audioBlob: false,
			recordingPreview: false
		})

		this.recorder.startRecording()
			.then(() => {
				this.setState({
					isRecording: true
				})
			})
			.catch( ( error ) => {
				console.error( 'Exception while start recording: ' + error )
				alert( 'Unable to record.' )
			})
	}

	stopRecording = () => {
		this.recorder.stopRecording()

		this.setState({
			isRecording: false
		})
	}

	onNewRecording = ( e ) => {
		let extension = 'wav'

		if ( e.detail.recording.mimeType.indexOf( 'webm' ) > -1 ) {
			extension = 'webm'
		} else if ( e.detail.recording.mimeType.indexOf( 'wav' ) > -1 ) {
			extension = 'wav'
		}

		this.setState({
			isRecording: false,
			finishedRecording: true,
			audioBlob: e.detail.blob,
			extension: extension,
			recordingPreview: e.detail.recording
		})

		this.props.onChange( this.props.id, {
			audioBlob: e.detail.blob,
			extension: extension,
			recordingPreview: e.detail.recording
		} )
	}

	handleRecordClick = () => {
		const { isRecording } = this.state

		if ( ! isRecording ) {
			this.startRecording()
		} else {
			this.stopRecording()
		}
	}

	render() {
		let { id, label, style } = this.props
		const { hasError, isRecording, finishedRecording, recordingPreview, acceptedRecording } = this.state
		let className = hasError ? 'form-item form-record has-error' : 'form-item form-record'

		if ( ! style ) {
			style = null
		}

		return (
			<div className={ className } style={ style }>
				<label dangerouslySetInnerHTML={ { __html: label } } />

				<div className="-record">
					<div className="-button" onClick={ this.handleRecordClick }>
						{ isRecording &&
							<i className="icon-playback-pause" aria-hidden="true"></i>
						||
							<svg viewBox="0 0 16 16">
								<path className="-mic-base" d="M9,12.86 L9,14 L9.5,14 C10.15,14 10.69,14.42 10.9,15 L5.1,15 C5.31,14.42 5.85,14 6.5,14 L7,14 L7,12.86 C5.28,12.41 4,10.86 4,9 L4,7 L5,7 L5,9 C5,10.66 6.34,12 8,12 C9.66,12 11,10.66 11,9 L11,7 L12,7 L12,9 C12,10.86 10.72,12.41 9,12.86 L9,12.86 L9,12.86 Z"/>
								<path className="-mic-top" d="M8,11 C6.9,11 6,10.1 6,9 L6,3 C6,1.9 6.9,1 8,1 C9.1,1 10,1.9 10,3 L10,9 C10,10.1 9.1,11 8,11 L8,11 L8,11 Z"/>
							</svg>
						}
					</div>

					{ finishedRecording && recordingPreview &&
						<div className="-preview">
							<audio src={ recordingPreview.blobUrl } controls="true" />
						</div>
					}
				</div>
			</div>
		)
	}
}

export default Record
